<div class="modal-header">
  <h4 class="modal-title">{{ "egbpid.navigationTitel" | translate }}</h4>
  <button
    (click)="activeModal.dismiss()"
    [ngbTooltip]="'modal.close' | translate"
    aria-label="Close"
    class="btn-close"
    type="button"></button>
</div>
<div class="modal-body">
  @if (personStammMaster && personStammMaster.version) {
    <span>{{ "egbpid.gehoertZuStammperson" | translate }}</span>
    <br />
    <br />
    <cap-kompakt-stammperson
      [auskunftsperre]="personStammMaster.auskunftsperre"
      [item]="personStammMaster.version"
      class="ms-2"
      format="STAMMPERSON_TYP01">
    </cap-kompakt-stammperson>
    <br />
    <br />
  }
  <span>{{ "egbpid.stammpersonAnzeigen" | translate }}</span>
</div>
<div class="modal-footer">
  <button (click)="activeModal.dismiss()" class="btn btn-outline-primary" type="button">{{ "Nein" | translate }}</button>
  <button (click)="activeModal.close()" #yesBtn autofocus class="btn btn-primary" type="button">{{ "Ja" | translate }}</button>
</div>
